import React, { useCallback, useEffect, useState } from "react";
import { Menu, Dropdown, Icon, Divider, Header } from "semantic-ui-react";
import { Link, useHistory, matchPath } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";




export function LeftMenu2() {
    const [indexCurrrentCompany, setIndexCurrrentCompany] = useState(0);
    const [urlParams, setUrlParams] = useState({});
    const { headerStore, companyStore, notificationStore, companyGroupStore } = useSelector((state) => {
        return {
            headerStore: state.header,
            companyStore: state.companyList,
            companyGroupStore: state.companyGroupStore,
            notificationStore: state.notificationStore,
        };
    });
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {

        const { params } = matchPath(location.pathname, { path: '/Company/:companyId' })
            || matchPath(location.pathname, { path: '/CompanyGroup/:companyGroupId' })
            || { params: {} };
        setUrlParams(params);
    }, [])
    useEffect(() => {

        const { params } = matchPath(location.pathname, { path: '/Company/:companyId' })
            || matchPath(location.pathname, { path: '/CompanyGroup/:companyGroupId' })
            || { params: {} };
        setUrlParams(params);
    }, [history.length])

    useEffect(() => {
        if (headerStore.logOut) {
            window.localStorage.clear();
            window.location.href = "login.html";
        }
    }, [headerStore.logOut]);

    function getCompany() {
        if (getCompanyList().length > 0) {
            return [getCompanyList()[indexCurrrentCompany]];
        }
        return [];
    }

    const handleChangeCompany = useCallback((e, target) => {
        setIndexCurrrentCompany(target.value);
    }, []);

    const handlerNotificationClick = useCallback(
        (e, data) => {
            var notify = notificationStore.list.find((x) => x.id == data.eventKey);
            if (!notify) {
                return;
            }

            dispatch(updateReadedNotify({ id: notify.id }));
            if (notify.code == "order") {
                const { orderId, companyId } = notify.data;
                history.push(`/Company/${companyId}/Order/${orderId}`);
            }
        },
        [notificationStore.list]
    );
    const getCompanyList = useCallback(
        () => {
            let res = [];
            for (let i of companyStore.companyList) {
                res.push({
                    isCompany: true,
                    id: i.id,
                    name: i.name,
                    icon: "building outline"
                })
            }
            for (let i of companyGroupStore.list) {
                res.push({
                    isCompany: false,
                    id: i.id,
                    name: i.name,
                    icon: "object ungroup"
                })
            }
            return res;

        },
        [companyStore.companyList, companyGroupStore.list]
    );
    useEffect(() => {
        const companies = getCompanyList();

        for (var i = 0; i < companies.length; i++) {
            if (!!urlParams.companyId && companies[i].isCompany
                && companies[i].id == urlParams.companyId) {
                setIndexCurrrentCompany(i);
                break;
            } else if (!!urlParams.companyGroupId && !companies[i].isCompany
                && companies[i].id == urlParams.companyGroupId) {
                setIndexCurrrentCompany(i);
                break;
            }
        }
    },
        [urlParams, companyStore.companyList, companyGroupStore.list])

    function renderFullCompanyMeny(item) {
        let prefix = "/Company/" + item.id;
        if (!item.isCompany) {
            prefix = '/CompanyGroup/' + item.id;
        }

        return [
            <Menu.Item key="company-name" as={Link} to={prefix + "/Dashboard"}>
                <Header size={"large"} inverted={true}>
                    {item.name}
                </Header>
            </Menu.Item>,
            <Menu.Item
                key="company-new-order"
                link
                as={Link}
                to={prefix + "/Order/New"}
                icon="add square"
                name="Новый заказ"
            />,
            <Menu.Item key="company-blank-1" />,
            <Menu.Item
                key="company-dashboard-0"
                link
                as={Link}
                to={prefix}
                //disabled={!item.isCompany}
                icon={!item.isCompany ? "lock" : ""}
                name="Незакрытые заказы"
            />,
            <Menu.Item
                key="company-dashboard-1"
                link
                as={Link}
                to={prefix + "/DashBoard/Summury"}
                icon={!item.isCompany ? "lock" : ""}
                name="Сводка по заказам"
            />,
            <Menu.Item
                key="company-dashboard-2"
                link
                as={Link}
                to={prefix + "/DashBoard/MediumSummury"}
                icon={!item.isCompany ? "lock" : ""}
                name="Расширеная сводка по заказам"
            />,
            <Menu.Item
                key="company-dashboard-3"
                link
                as={Link}
                to={prefix + "/DashBoard/Realization"}
                icon={!item.isCompany ? "lock" : ""}
                name="Сводка по продажам"
            />,
            <Menu.Item
                key="company-dashboard-OrderCalendar"
                link
                as={Link}
                to={prefix + "/DashBoard/OrderCalendar"}
                icon={!item.isCompany ? "lock" : ""}
                name="Календарь заказов"
            />,
            <Menu.Item key="company-blank-2" />,
            <Menu.Item key="company-customers" as={Link} to={prefix + "/Customer"}>

                <Icon name={!item.isCompany ? "lock" : "users"} /> Клиенты
            </Menu.Item>,
            <Menu.Item key="company-phone-call" as={Link} to={prefix + "/Call"}>
                <Icon name={!item.isCompany ? "lock" : "call square"} /> Звонки
            </Menu.Item>,
            <Menu.Item key="company-stock" as={Link} to={prefix + "/Stock"}>
                <Icon name={!item.isCompany ? "lock" : "warehouse"} /> Склад
            </Menu.Item>,
            <Menu.Item key="company-settings" as={Link} to={prefix + "/Operations"}>
                <Icon name="cogs" /> Настройка компании
            </Menu.Item>,
            <Menu.Item key="company-reports" as={Link} to={prefix + "/Report"} >
                <Icon name={!item.isCompany ? "lock" : "area graph"} /> Отчеты
            </Menu.Item>,
        ];
    }
    return (
        <Menu fixed={"left"} inverted={true} vertical id="sidebar">
            {getCompany().map((item) => {
                let res = [
                    //<Menu.Item   name={"Компания:"} />
                ];
                if (getCompanyList().length > 1) {
                    res.push(
                        <Menu.Item key="select-company" fitted>
                            <div> Компания: </div>
                            <Dropdown
                                placeholder="Выбрать компанию"
                                selection
                                options={Array.from(getCompanyList(), (x, index) => {
                                    return { text: x.name, value: index, icon: x.icon };
                                })}
                                value={indexCurrrentCompany}
                                onChange={handleChangeCompany}
                            />

                        </Menu.Item>
                    );
                } else {
                    res.push(
                        <Menu.Item
                            key="company-name"
                            color="grey"
                            active
                            name={getCompanyList()[0].name}
                        />
                    );
                }

                res.push(renderFullCompanyMeny(item));
                return res;
            })}
            <Divider />
            <Menu.Item as={Link} to={"/PrintCenter"}>
                <Icon name="print" /> Центр печати
            </Menu.Item>
            <Menu.Item as={Link} to={"/Feedback"}>
                <Icon name="send" /> Центр вопросов
            </Menu.Item>
            <Menu.Item as={Link} to={"/Info"}>
                <Icon name="info" /> О приложении
            </Menu.Item>
        </Menu>
    );
}

